"use client"

import { SettingsSection } from "./settings/settings-section"
import { SettingsToggle } from "./settings/settings-toggle"
import { Bell } from "lucide-react"

export function NotificationSettings() {
  return (
    <SettingsSection title="Notification Settings" icon={Bell}>
      <div className="flex items-center justify-between p-4 rounded-lg bg-slate-50">
        <div className="flex flex-col">
          <p className="text-base font-bold text-slate-900">New Career Path Unlocked</p>
          <p className="text-sm font-normal text-slate-600">Get notified when you unlock a new path.</p>
        </div>
        <SettingsToggle id="toggle-career" defaultChecked={true} />
      </div>
      <div className="flex items-center justify-between p-4 rounded-lg bg-slate-50">
        <div className="flex flex-col">
          <p className="text-base font-bold text-slate-900">Weekly Progress Reminders</p>
          <p className="text-sm font-normal text-slate-600">A friendly nudge to check your progress.</p>
        </div>
        <SettingsToggle id="toggle-reminders" defaultChecked={false} />
      </div>
    </SettingsSection>
  )
}
